// 封装操作localstorage本地存储的方法  模块化

function getLanguageFromURL() {
    return 'en';
    // const url = window.location.href;
    // if (url.includes('/en')) {
    //     return 'en';
    // } else if (url.includes('/cn')) {
    //     return 'cn';
    // } else if (url.includes('/rus')) {
    //     return 'rus';
    // } else if (url.includes('/vnm')) {
    //     return 'vnm';
    // } else if (url.includes('/tha')) {
    //     return 'tha';
    // } else if (url.includes('/mas')) {
    //     return 'mas';
    // } else if (url.includes('/spa')) {
    //     return 'spa';
    // } else {
    //     // 默认语言
    //     return 'en';
    // }
}

let language = getLanguageFromURL()

var storage = {
    // 定义语言前缀
    languagePrefix: {
        cn: 'cn_',
        en: 'en_',
        rus: 'rus_',
        vnm: 'vnm_',
        tha: 'tha_',
        mas: 'mas_',
        spa: 'spa_',
        // 可以添加其他语言的前缀
    },

    set(key, value) {
        if (!this.languagePrefix[language]) {
            throw new Error('Invalid language code');
        }
        let obj = {
            data: value,
            // time: Date.now(),
            // storageTime:  60 * 60
            // storageTime: 24 * 60 * 60 * 1000
            // storageTime: sTime
        }
        // 添加语言前缀到键
        key = this.languagePrefix[language] + key;
        localStorage.setItem(key, JSON.stringify(obj));
        // localStorage.setItem(key, JSON.stringify(value));
    },

    get(key) {
        if (!this.languagePrefix[language]) {
            throw new Error('Invalid language code');
        }
        // 添加语言前缀到键
        key = this.languagePrefix[language] + key;
        let obj = localStorage.getItem(key)
        obj = JSON.parse(obj)
        if (null == obj) {
            // if (null == obj || (Date.now() - obj.time > obj.storageTime)) {
            // localStorage.removeItem(key);
            return null
        }
        return obj.data
        // return JSON.parse(localStorage.getItem(key));
    },

    getForIndex(index) {
        return localStorage.key(index);
    },

    getKeys() {
        if (!this.languagePrefix[language]) {
            throw new Error('Invalid language code');
        }
        let items = this.getAll();
        let keys = [];
        for (let index = 0; index < items.length; index++) {
            if (items[index] && items[index].key.startsWith(this.languagePrefix[language])) {
                keys.push(items[index].key);
            }
        }
        return keys;
    },

    getLength() {
        return localStorage.length;
    },

    getSupport() {
        return (typeof (Storage) !== "undefined") ? true : false;
    },

    remove(key) {
        if (!this.languagePrefix[language]) {
            throw new Error('Invalid language code');
        }
        // 添加语言前缀到键
        key = this.languagePrefix[language] + key;
        localStorage.removeItem(key);
    },

    removeAll() {
        if (!this.languagePrefix[language]) {
            throw new Error('Invalid language code');
        }
        let keys = this.getKeys();
        keys.forEach(key => {
            localStorage.removeItem(key);
        });
    },

    getAll() {
        if (!this.languagePrefix[language]) {
            throw new Error('Invalid language code');
        }
        let len = localStorage.length;  // 获取长度
        let arr = new Array(); // 定义数据集
        for (var i = 0; i < len; i++) {
            // 获取key 索引从0开始
            var getKey = localStorage.key(i);
            // 如果键以指定语言的前缀开始，则获取它的值
            if (getKey.startsWith(this.languagePrefix[language])) {
                // 获取key对应的值
                var getVal = localStorage.getItem(getKey);
                // 放进数组
                arr[i] = {
                    'key': getKey,
                    'val': getVal,
                }
            }
        }
        return arr;
    }
}

export default storage;
